module.exports = __webpack_public_path__ + "img/airlines-en.c2b986f4.svg";